module.exports = require("@angular/material/tabs");